const dashboard = () => import('../views/produce/dashboard/index.vue')
const flowTemplates = () => import('../views/produce/flow/flow_templates.vue')
const flowNotes = () => import('../views/produce/flow/flow_notes.vue')
const nodedit = () => import('../views/produce/flow/nodedit.vue')
const flows = () => import('../views/produce/flow/flows.vue')
const products = () => import('../views/produce/product/products.vue')
const productDetail = () => import('../views/produce/product/detail.vue')
const flowHistories = () => import('../views/produce/flow/flow_histories.vue')

const undoneTasks = () => import('../views/produce/task/undone.vue')
const manhour = () => import('../views/produce/statistics/manhour.vue')
const manhourDetail = () => import('../views/produce/statistics/manhour_detail.vue')

export default [
    {
        path: '/produce/dashboard',
        component: dashboard,
        name: 'moduleDashboard',
        meta: {
            module_name: 'produce',
        }
    },
    {
        path: '/flow_templates',
        component: flowTemplates,
        meta: {
            module_name: 'produce',
            en_name: 'flow_templates',
            auth_id: 41101
        }
    },
    {
        path: '/flow_nodes',
        component: flowNotes,
        meta: {
            module_name: 'produce',
            en_name: 'flow_nodes',
            auth_id: 41101
        }
    },
    {
        path: '/nodedit',
        component: nodedit,
        meta: {
            module_name: 'produce',
            en_name: 'flow_templates',
            auth_id: 41102
        }
    },
    {
        path: '/flows',
        component: flows,
        meta: {
            module_name: 'produce',
            en_name: 'flows',
            auth_id: 43103
        }
    },
    {
        path: '/products',
        component: products,
        meta: {
            module_name: 'produce',
            en_name: 'products',
            auth_id: 43101
        }
    },
    {
        path: '/products/:id',
        component: productDetail,
        meta: {
            module_name: 'produce',
            en_name: 'products',
            auth_id: 43101
        }
    },
    {
        path: '/flow_histories',
        component: flowHistories,
        meta: {
            module_name: 'produce',
            en_name: 'flow_histories',
            flowStatus: 2,
            auth_id: 43103
        }
    },
    {
        path: '/pause_flows',
        component: flowHistories,
        meta: {
            module_name: 'produce',
            en_name: 'pause_flows',
            flowStatus: 4,
            auth_id: 43103
        }
    },
    {
        path: '/cancel_flows',
        component: flowHistories,
        meta: {
            module_name: 'produce',
            en_name: 'cancel_flows',
            flowStatus: 3,
            auth_id: 43103
        }
    },
    {
        path: '/mytask',
        component: undoneTasks,
        meta: {
            module_name: 'produce',
            en_name: 'mytask',
            auth_id: 42101
        }
    },
    {
        path: '/statistics/manhour',
        component: manhour,
        meta: {
            module_name: 'produce',
            en_name: 'statistics',
            auth_id: 44101
        }
    },
    {
        path: '/statistics/manhour_detail',
        component: manhourDetail,
        meta: {
            module_name: 'produce',
            en_name: 'statistics',
            auth_id: 44101
        }
    }
]
